module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('asideNav', {
    attrs: {
      "isShowDot": _vm.isShowDot
    }
  }, [_c('div', {
    staticClass: "systemMessage"
  }, [_c('div', {
    staticClass: "messageTitle"
  }, [_vm._v("系统消息（"), _c('strong', [_vm._v(_vm._s(_vm.systemMessage))]), _vm._v("）")]), _vm._v(" "), _c('ul', {
    staticClass: "messageList"
  }, _vm._l((_vm.messageList), function(item, index) {
    return _c('li', {
      key: item.id,
      class: {
        'active': index == _vm.listIndex
      },
      on: {
        "mouseenter": function($event) {
          return _vm._mouseenter(index)
        },
        "mouseleave": function($event) {
          return _vm._mouseleave(index)
        }
      }
    }, [_c('div', {
      staticClass: "meeting-top"
    }, [(item.messageTopicCode === '08' || item.messageTopicCode === '09') ? _c('i', {
      staticClass: "iconfont icon-xinjiankecheng",
      staticStyle: {
        "font-size": "30px !important"
      }
    }) : _c('i', {
      staticClass: "iconfont icon-xinjianhuiyi",
      staticStyle: {
        "font-size": "30px !important"
      }
    }), _vm._v(" "), _c('p', {
      on: {
        "click": function($event) {
          return _vm.gotoRouter(item)
        }
      }
    }, [_vm._v(_vm._s(item.msgContent))])]), _vm._v(" "), _c('div', {
      staticClass: "meeting-btm"
    }, [_c('p', [_vm._v(_vm._s(item.formUserName))]), _vm._v(" "), (_vm.see && index == _vm.listIndex) ? _c('span', [_c('i', {
      staticClass: "icon_msg icon-bukejian",
      attrs: {
        "title": "点击忽略"
      },
      on: {
        "click": function($event) {
          return _vm.addIgnore(index)
        }
      }
    })]) : _c('span', [(item.readStatus === '3') ? _c('i', {
      staticClass: "msg_read"
    }, [_vm._v("已读")]) : _vm._e(), (item.isTimeOut) ? _c('i', {
      staticClass: "msg_read"
    }, [_vm._v("已过期")]) : _vm._e(), _vm._v(_vm._s(item.createDate_new))])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "allMessage"
  }, [_c('p', [_vm._v("会议消息 "), _c('strong', [_vm._v(_vm._s(_vm.meetingMessage))])]), _vm._v(" "), _c('p', [_vm._v("课程消息 "), _c('strong', [_vm._v(_vm._s(_vm.courseMessage))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.addIgnore
    }
  }, [_vm._v("忽略全部")])])])]), _vm._v(" "), _c('passwordInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popPassword),
      expression: "popPassword"
    }],
    attrs: {
      "isShowPassword": _vm.popPassword
    },
    on: {
      "clossPassword": _vm.clossPassword,
      "inputPassword": _vm.inputPassword
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-ac108baa","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/message/systemMessage.vue
// module id = 595
// module chunks = 1 2 3 4 5 6 7 8